// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"59c9bfab482775972aeb","293":"cbad94a1c2635ec30a72","454":"c2507243d08deaac3af5"}[chunkId] + ".js";
};